import { useTranslation } from "react-i18next";
import PolicyPageLayout, {
  PolicySection,
} from "../shared/components/PolicyPageLayout";

const TermsAndConditions = () => {
  const { t } = useTranslation("home");

  return (
    <PolicyPageLayout title={t("termsAndConditions.title")}>
      <PolicySection>{t("termsAndConditions.mainContent")}</PolicySection>
      <PolicySection>{t("termsAndConditions.accuracy")}</PolicySection>
      <PolicySection>{t("termsAndConditions.liability")}</PolicySection>
      <PolicySection>{t("termsAndConditions.jurisdiction")}</PolicySection>
      <PolicySection>{t("termsAndConditions.hyperlinks")}</PolicySection>
      <PolicySection title={t("termsAndConditions.disclaimer.title")}>
        {t("termsAndConditions.disclaimer.content")}
      </PolicySection>
    </PolicyPageLayout>
  );
};

export default TermsAndConditions;
